/* eslint-disable import/no-unresolved */
import ContextMenu from "pages/_components/ContextMenu";
import TransactionTicket from "pages/_components/TransactionTicket";
import { bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { push } from "react-router-redux";
import { selectors as addLimitRequestSelectors } from "reducers/addLimitRequest";
import { actions as formActions } from "reducers/form";
import * as i18n from "util/i18n";
import { resizableRoute } from "pages/_components/Resizable";
import { resolveAddLimitTicketGoBackTarget } from "util/addLimitRequestNavigation";
import AddLimitTransactionData from "./AddLimitTransactionData";

class AddLimitTicket extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        summary: shape({}).isRequired,
        isDesktop: bool.isRequired,
        fetching: bool.isRequired,
        embeddedInV3Shell: bool,
        lastHrefPathname: string,
        location: shape({
            pathname: string,
            search: string,
            state: shape({}),
        }),
    };

    static defaultProps = {
        embeddedInV3Shell: false,
        lastHrefPathname: "",
        location: undefined,
    };

    state = {
        showDrawerMobile: false,
    };

    componentDidMount() {
        const { summary, dispatch } = this.props;
        if (!summary?.idTransaction) {
            dispatch(push("/pendingTransaction/list"));
        }
    }

    resolveBackTarget = () => {
        const { location, lastHrefPathname } = this.props;
        return resolveAddLimitTicketGoBackTarget(location, lastHrefPathname);
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(push(this.resolveBackTarget()));
    };

    buttonsDetailFinished = () => {
        const { dispatch } = this.props;

        const buttons = [];

        buttons.push({
            label: "global.goToHome",
            bsStyle: "primary",
            onClick: () => {
                dispatch(push("/desktop"));
            },
        });

        return buttons;
    };

    signTransaction = () => {
        const { dispatch, summary, isDesktop, location } = this.props;
        const title = "activities.temporary.limit.increase.request";
        const signTransactionData = <AddLimitTransactionData isDesktop={isDesktop} />;

        const idActivity = "temporary.limit.increase.request";

        const goBackState = location?.pathname
            ? `${location.pathname}${location.search || ""}`
            : "/addlimitrequest/pending";
        dispatch(push({ pathname: "/transactions/sign", state: { goBackState } }));
        dispatch(
            formActions.signTransactionData({
                idTransaction: summary?.idTransaction,
                idActivity,
                idForm: "",
                content: signTransactionData,
                title,
                credentials: ["otp"],
                pendingDispatch: summary?.pendingDispatch,
            }),
        );
        dispatch(formActions.setFetching(false));
    };

    rightContentTransactionScheme = () => {
        const { isDesktop, summary } = this.props;
        if (isDesktop || summary?.idTransactionStatus === "FINISHED") {
            return <></>;
        }
        return (
            <>
                {summary?.idTransactionStatus !== "CANCELLED" && (
                    <ContextMenu
                        isDesktop={isDesktop}
                        color={!isDesktop ? "white" : undefined}
                        buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                        items={[
                            {
                                label: "pendingTransaction.info.scheme",
                                onClick: () => this.setState({ showDrawerMobile: true }),
                            },
                        ]}
                    />
                )}
            </>
        );
    };

    buttonsDetailPending = () => [];

    centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1 className="w-100 m-0 px-2">{i18n.get("activities.temporary.limit.increase.request")}</h1>
        </div>
    );

    getTitle = () => "activities.temporary.limit.increase.request";

    render() {
        const { isDesktop, summary, fetching, embeddedInV3Shell, lastHrefPathname, location } = this.props;
        const { showDrawerMobile } = this.state;
        const isPending = summary?.idTransactionStatus === "PENDING";
        const backTarget = this.resolveBackTarget();

        return (
            <TransactionTicket
                embeddedInV3Shell={embeddedInV3Shell}
                embeddedV3GoBackPath={backTarget}
                embeddedV3UseResolvedGoBackPath
                lastHrefPathname={lastHrefPathname}
                location={location}
                handleBack={this.handleBack}
                notificationScope="limitTicket"
                handleClick={this.handleDownload}
                handleClickMessage="global.download"
                headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                centerElement={isDesktop ? undefined : this.centerContentMobile}
                hasInlineButtons
                hideMobileMenu={!isDesktop}
                summary={summary}
                rightContent={() => this.rightContentTransactionScheme()}
                buttonsDetail={isPending ? this.buttonsDetailPending() : this.buttonsDetailFinished()}
                isDesktop={isDesktop}
                summaryTitle={this.getTitle()}
                closeMobileDrawer={() => this.setState({ showDrawerMobile: false })}
                onSignTicket={this.signTransaction}
                showDrawerMobile={showDrawerMobile}
                fetching={fetching}
                ignoreHomeButton
                downloadImageWhite={!isDesktop}>
                <AddLimitTransactionData isDesktop={isDesktop} />
            </TransactionTicket>
        );
    }
}

const mapStateToProps = (state) => ({
    summary: addLimitRequestSelectors.getSummary(state),
    fetching: addLimitRequestSelectors.getFetching(state),
    lastHrefPathname: (state.status?.lastHref && state.status.lastHref.pathname) || "",
});

export default compose(connect(mapStateToProps), resizableRoute)(AddLimitTicket);
